const listAttributes = [
  'type',
  'leadId',
  'gradYear',
  'school',
  'schoolId',
  'schoolLabel',
  'schoolShortLabel',
  'firstName',
  'lastName',
  'parentFirstName',
  'parentLastName',
  'email',
  'phoneNumber',
  'parentEmail',
  'parentPhoneNumber',
] as const;

const getAttributes = [
  ...listAttributes,
  'creationDatetime',
  'gradYear',
  'school',
  'birthday',
  'streetAddress',
  'country',
  'postcode',
] as const;

// `schoolLabel` and `schoolShortLabel` are derived, never accepted from a caller: the
// leads entity resolves them from `schoolId` and injects them before encoding, so they
// must survive this mask
const updateAttributes = [
  'firstName',
  'lastName',
  'gradYear',
  'school',
  'schoolId',
  'schoolLabel',
  'schoolShortLabel',
  'email',
  'phoneNumber',
  'birthday',
  'parentFirstName',
  'parentLastName',
  'parentEmail',
  'parentPhoneNumber',
  'streetAddress',
  'country',
  'postcode',
] as const;

const convertAttributes = [
  'firstName',
  'lastName',
  'gradYear',
  'school',
  'schoolId',
  'email',
  'phoneNumber',
  'birthday',
  'parentFirstName',
  'parentLastName',
  'parentEmail',
  'parentPhoneNumber',
  'streetAddress',
  'country',
  'postcode',
] as const;

const requiredConvertAttributes = [
  'firstName',
  'lastName',
  'gradYear',
  'school',
  'schoolId',
  'email',
  'phoneNumber',
  'parentEmail',
  'parentPhoneNumber',
] as const;

const searchAttributes = [
  'gradYear',
  'firstName',
  'lastName',
  'parentFirstName',
  'parentLastName',
  'email',
  'phoneNumber',
  'parentEmail',
  'parentPhoneNumber',
  'school',
] as const;

export const LeadAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
  Convert: convertAttributes,
  RequiredConvert: requiredConvertAttributes,
  Search: searchAttributes,
};
